export const CATALOG_META = {
  layout: 'main',
  auth: true,
  availableName: 'isCatalog'
}
